export class Workspace {
  workspaceId: number;
  workspaceName: string;
  workspaceLogo: string;
  workspaceColor: string;
  status: string;
  roleId: number;
  roleSlug: string;
  roleName: string;
}
